import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatCardProps {
  icon: ReactNode;
  value: string | number;
  label: string;
}

const StatCard = ({ icon, value, label }: StatCardProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        border: "2px solid #f0f0f0",
        borderRadius: "20px",
        padding: "28px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        bgcolor: "#ffffff",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderColor: "#E87722",
        },
      }}
    >
      {icon}
      <Typography fontSize="32px" fontWeight="700" color="#1a3a3a" sx={{ mt: 0.5 }}>
        {value}
      </Typography>
      <Typography fontSize="14px" color="#6b7280" fontWeight="500">
        {label}
      </Typography>
    </Box>
  );
};

export default StatCard;
